export default __webpack_public_path__ + "static/media/NexusTec.d223238e.png";